/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  GetMetaMcpServerUsagePayload,
  GetMetaMcpServerUsagePayload$Outbound,
  GetMetaMcpServerUsagePayload$outboundSchema,
} from "../components/getmetamcpserverusagepayload.js";

export type GetMetaMcpServerUsageSecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type GetMetaMcpServerUsageSecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type GetMetaMcpServerUsageSecurity = {
  option1?: GetMetaMcpServerUsageSecurityOption1 | undefined;
  option2?: GetMetaMcpServerUsageSecurityOption2 | undefined;
};

export type GetMetaMcpServerUsageRequest = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  getMetaMcpServerUsagePayload: GetMetaMcpServerUsagePayload;
};

/** @internal */
export type GetMetaMcpServerUsageSecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const GetMetaMcpServerUsageSecurityOption1$outboundSchema: z.ZodMiniType<
  GetMetaMcpServerUsageSecurityOption1$Outbound,
  GetMetaMcpServerUsageSecurityOption1
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function getMetaMcpServerUsageSecurityOption1ToJSON(
  getMetaMcpServerUsageSecurityOption1: GetMetaMcpServerUsageSecurityOption1,
): string {
  return JSON.stringify(
    GetMetaMcpServerUsageSecurityOption1$outboundSchema.parse(
      getMetaMcpServerUsageSecurityOption1,
    ),
  );
}

/** @internal */
export type GetMetaMcpServerUsageSecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const GetMetaMcpServerUsageSecurityOption2$outboundSchema: z.ZodMiniType<
  GetMetaMcpServerUsageSecurityOption2$Outbound,
  GetMetaMcpServerUsageSecurityOption2
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function getMetaMcpServerUsageSecurityOption2ToJSON(
  getMetaMcpServerUsageSecurityOption2: GetMetaMcpServerUsageSecurityOption2,
): string {
  return JSON.stringify(
    GetMetaMcpServerUsageSecurityOption2$outboundSchema.parse(
      getMetaMcpServerUsageSecurityOption2,
    ),
  );
}

/** @internal */
export type GetMetaMcpServerUsageSecurity$Outbound = {
  Option1?: GetMetaMcpServerUsageSecurityOption1$Outbound | undefined;
  Option2?: GetMetaMcpServerUsageSecurityOption2$Outbound | undefined;
};

/** @internal */
export const GetMetaMcpServerUsageSecurity$outboundSchema: z.ZodMiniType<
  GetMetaMcpServerUsageSecurity$Outbound,
  GetMetaMcpServerUsageSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => GetMetaMcpServerUsageSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => GetMetaMcpServerUsageSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function getMetaMcpServerUsageSecurityToJSON(
  getMetaMcpServerUsageSecurity: GetMetaMcpServerUsageSecurity,
): string {
  return JSON.stringify(
    GetMetaMcpServerUsageSecurity$outboundSchema.parse(
      getMetaMcpServerUsageSecurity,
    ),
  );
}

/** @internal */
export type GetMetaMcpServerUsageRequest$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  GetMetaMcpServerUsagePayload: GetMetaMcpServerUsagePayload$Outbound;
};

/** @internal */
export const GetMetaMcpServerUsageRequest$outboundSchema: z.ZodMiniType<
  GetMetaMcpServerUsageRequest$Outbound,
  GetMetaMcpServerUsageRequest
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    getMetaMcpServerUsagePayload: GetMetaMcpServerUsagePayload$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      getMetaMcpServerUsagePayload: "GetMetaMcpServerUsagePayload",
    });
  }),
);

export function getMetaMcpServerUsageRequestToJSON(
  getMetaMcpServerUsageRequest: GetMetaMcpServerUsageRequest,
): string {
  return JSON.stringify(
    GetMetaMcpServerUsageRequest$outboundSchema.parse(
      getMetaMcpServerUsageRequest,
    ),
  );
}
